import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Spin,
  InputNumber,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import CustomButton from "../../../components/custom/CustomButton";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const NewEmployee = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [officeOptions, setOfficeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    const params = {
      orderBy: "name",
      sortOrder: "ASC",
    };
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Offices, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        let tempOfficeOptions = [];

        useForm.setFieldsValue({
          joiningDate: dayjs(),
          officeId: objList[0]?.id,
          isLoanOfficer: true,
        });

        objList?.forEach((element) => {
          tempOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        setOfficeOptions(tempOfficeOptions);
      }
    });
    setIsLoading(false);
  }

  function onCancel() {
    navigate("/sms0200", { state: state });
  }

  const onSubmit = (formValues) => {
    formValues.joiningDate = BOM.DateTime(formValues.joiningDate, "only-date");
    const params = {
      status: "all",
    };
    const body = {
      ...formValues,
      locale: "en",
      params,
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.Staff,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newEmployeeMsg);
          navigate("/sms0200");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/sms0200");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.createEmployees}
        pageItems={staticConfig.newEmployeeBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              {/* DETAILS  */}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.branch}
                  name="officeId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.branch),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.branch,
                      "select"
                    )}
                    options={officeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.firstName}
                  name="firstname"
                  rules={BOM.fieldRules("firstName", true)}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.firstName
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.lastName}
                  name="lastname"
                  rules={BOM.fieldRules("lastName", true)}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.lastName)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.isLoanOfficer}
                  name="isLoanOfficer"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.isLoanOfficer,
                      "select"
                    )}
                    options={staticConfig.yesOrNo}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  rules={[
                    () => ({
                      validator(_, value) {
                        if (!value) {
                          return Promise.reject(
                            new Error(
                              BOM.CheckReqFld(labelConfig.mobileNumberforSMS)
                            )
                          );
                        }
                        if (value?.length > 11 || value?.length < 11) {
                          return Promise.reject(
                            new Error("Mobile number must be exactly 11 digits")
                          );
                        }
                        if (!/^[0-9]{11}$/.test(value)) {
                          return Promise.reject(
                            new Error("Mobile number must contain only numbers")
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.mobileNumberforSMS),
                  //   },
                  //   {
                  //     len: 11,
                  //     message: "Mobile number must be exactly 11 digits",
                  //   },
                  // ]}
                  label={labelConfig.mobileNumberforSMS}
                  name="mobileNo"
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.mobileNumberforSMS
                    )}
                  />
                  {/* <InputNumber
                    style={{ width: "100%" }}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.mobileNumberforSMS)}
                  /> */}
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.joinedOn}
                  name="joiningDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.joinedOn),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.joinedOn}`,
                      "select"
                    )}
                    style={{
                      width: "100%",
                      height: 35,
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_STAFF") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default NewEmployee;
